import { render, staticRenderFns } from "./DetailsPaymentsItem.vue?vue&type=template&id=0d930acd&scoped=true&"
import script from "./DetailsPaymentsItem.vue?vue&type=script&lang=js&"
export * from "./DetailsPaymentsItem.vue?vue&type=script&lang=js&"
import style0 from "./DetailsPaymentsItem.vue?vue&type=style&index=0&id=0d930acd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d930acd",
  null
  
)

export default component.exports